import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}

import {onMounted, ref, watch, withDefaults} from 'vue'
import InputText from 'primevue/inputtext'

// Define types
type InputFieldProps = {
  id: string
  label: string
  modelValue: any
  submitted: boolean,
  vualidate: any,
  class?: string
}

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    id: null,
    label: null,
    modelValue: null,
    submitted: { type: Boolean, default: false },
    vualidate: null,
    class: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: emits }) {

const props = __props as { id: string, label: string, modelValue: any, submitted: boolean, vualidate: any, class: string };



// Define hooks
onMounted(() => {
  mv.value = props.modelValue
})

// Define emits


// Define ref/reactive properties
const mv = ref<string | null>(null)

// Define functions
function processValueChange(event: Event) {
  emits('update:modelValue', mv.value)
}

// Define hooks
watch(() => props.modelValue, (current, prev) => {
  mv.value = current
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, [
    _createElementVNode("label", { for: __props.id }, [
      _createTextVNode(_toDisplayString(props.label) + " ", 1),
      (__props.vualidate.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createVNode(_unref(InputText), {
      id: __props.id,
      class: _normalizeClass([{'p-invalid':__props.vualidate.$invalid && props.submitted}, "p-inputtext"]),
      onChange: processValueChange,
      onKeyup: processValueChange,
      modelValue: mv.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mv).value = $event))
    }, null, 8, ["id", "class", "modelValue"]),
    (__props.vualidate.$invalid && props.submitted)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(__props.vualidate.required.$message.replace('Value', props.label)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})